<template >
<vs-popup title="Fiyat Listesi" fullscreen :active.sync="isSidebarActiveLocal" v-esc="escape">
    <vs-popup
      class="holamundo"
      title="Fiyat Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Fiyatı Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç
        </vs-button>
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <div >
      <div class="popup">
        <div class="popup-body">
          <div id="pager" class="mt-3">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <h1 class="mx-auto my-3">{{ name }}</h1>
        </vs-col>
      </vs-row>

    </div>
          <label>Ürün Seçimi</label>
        <v-select label-placeholder="Ürün Seçimi" v-model="selectedProduct" itemid="id" label="name" class="w-full" v-if="$isCenterBranch()"
            placeholder="Ürün Seçimi" :options="$currentUser.branch.id == 1 ? data3.data : []" :clearable="false">
          </v-select>
          <vs-row vs-type="flex" vs-w="12" class="mb-2" v-if="isSetPriceListPermission">
            <vs-col vs-type="flex" vs-w="6" class="pr-2">
          <vs-input  id="price2" name="Satış Fiyatı" v-validate="'required'"
                    v-model="additiveprice" class="w-full" label-placeholder="Satış Fiyatı"/>
                  </vs-col>
                  <vs-col vs-type="flex" vs-w="6" class="pr-2">
                  <vs-button
                  v-if="$isCenterBranch()"
                  color="success"
                  type="gradient"
                  @click="addedData()"
                  >Fiyat Ekle
                </vs-button>
              </vs-col>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" class="mb-2">
                    <vs-col vs-type="flex" class="w-auto">
                      <vs-input v-model="filterText" type="text" placeholder="Filtrele"/>
                    </vs-col>
                    <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button style="margin-left: 15px;" @click="getExcel" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                               color="transparent" icon-pack="feather" icon="icon-download"/>
                  </vx-tooltip>
                </vs-col>
                </vs-row>
            <table>
        <thead>
          <tr>
            <th>Ürün İsmi</th>
            <th>Kategori</th>
            <th>Fiyat</th>
            <th v-if="isSetPriceListPermission"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in filteredItems" :key="item.id">
            <td>{{ item.productName }}</td>
            <td>{{ item.categoryName }}</td>
            <td><vs-input :disabled="!isSetPriceListPermission"  id="price" name="Satış Fiyatı" v-validate="'required'"
                    v-model="item.price" class="w-full" label-placeholder="Satış Fiyatı"/></td>
            <td v-if="isSetPriceListPermission"><vs-col v-if="isSetPriceListPermission" vs-type="flex" vs-w="12">
             
                  <vx-tooltip
                    text="Fiyatı Sil"
                    position="top"
                  >
                    <feather-icon
                    icon="TrashIcon"
                      svgClasses="w-5 h-5 text-danger stroke-current"
                      @click.stop="
                        deletedId = item;
                        deletePopupActive = true;
                      "
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    text="Fiyatı Güncelle"
                    position="top" style="margin-left: 1.5rem;"
                  >
                    <feather-icon
                    icon="RefreshCwIcon"
                      svgClasses="w-5 h-5 text-danger stroke-current"
                      @click.stop="editPrice(item.productId,item.price,item.isExtra)"
                    />
                  </vx-tooltip>
                </vs-col>
                
            </td>
          </tr>
        </tbody>
      </table>
        </div>
        
      </div>
    </div>
    <vs-button
                  v-if="$isCenterBranch() && isSetPriceListPermission"
                  color="success"
                  type="gradient"
                  @click="updatedData()"
                  >Toplu Güncelle
                </vs-button>
</vs-popup>
  </template>
  <script>
  import {
    deletePriceById,
    setBranchProductPrice,
    updatedAllDataByList,
    GetPriceListExcel
  } from "@/api/BranchProductPrice.js";
  import {isGranted} from "@/utils/auth";
  export default {
    props: {
        isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {}
      },
      data2: {
        type: Array,
        default: () => []
      },
      data3: {
        type: Array,
        default: () => []
      },
      name: {
        type: String,
        default: () => ""
      }
    },
    data(){
        return {
            deletePopupActive: false,
            deletedId: null,
            selectedProduct:null,
            lists:[],
            additiveprice:0,
            newProductPrice:{},
            filterText: ''
        }
    },
    
   
    computed: {
      filteredItems() {
  return this.data2.data.filter(item => {
    const productNameMatches = item.productName.toLocaleLowerCase('tr-TR').includes(this.filterText.toLocaleLowerCase('tr-TR'));
    const categoryNameMatches =item.categoryName && item.categoryName.toLocaleLowerCase('tr-TR').includes(this.filterText.toLocaleLowerCase('tr-TR'));
    
    // productName veya categoryName eşleşiyorsa true döndür
    return productNameMatches || categoryNameMatches;
  });
},
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive;
        },
        set(val) {
          if (!val) {
            this.$emit("close");
           // this.$validator.reset();
           // this.initValues();
          }
        }
      },
      isSetPriceListPermission(){
      return isGranted("price_list_set")
    }
    },
    methods: {
      getExcel() {
      GetPriceListExcel(parseFloat(this.data)).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Ürün Fiyat Listesi' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
        deleteData(id) {
      deletePriceById(this.data,id).then((res) => {
        if (res && res.status == 200) {
        //   this.$store.dispatch("branch/removeBranch", id).then(() => {
        //     this.deletePopupActive = false;
        //     this.$vs.notify({
        //       color: "success",
        //       title: "Silme İşlemi",
        //       text: "Şube Başarıyla Silindi",
        //     });
        //   });
        this.deletePopupActive = false;
        this.data2.data = this.data2.data.filter(item => item.productId !== id);
        this.$vs.notify({
               color: "success",
               title: "Silme İşlemi",
               text: "Fiyat Başarıyla Silindi",
             });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !",
          });
        }
      });
    },
    updatedData() {
for (var i = 0; i < this.data2.data.length; i++) {
  this.data2.data[i].price = parseFloat(this.data2.data[i].price);
  this.data2.data[i].isExtra = this.data2.data[i].isExtra;
}
       updatedAllDataByList(this.data2.data).then((res) => {
        if (res && res.status == 200) {
          this.$vs.notify({
               color: "success",
               title: "Fiyat Güncelleme İşlemi",
               text: "Başarıyla Fiyatlar Güncellendi",
             });
        }else{
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Fiyat Güncelleme İşlemi Başarısız !",
          });
        }})
      },
    addedData() {
      this.newProductPrice.price =  parseFloat(this.additiveprice)
            this.newProductPrice.productId = parseFloat(this.selectedProduct.id)
            this.newProductPrice.branchProductPriceListId=parseFloat(this.data); 
            this.newProductPrice.isExtra = this.selectedProduct.isExtra;
      setBranchProductPrice(this.newProductPrice).then((res) => {
        if (res && res.status == 200) {
        //   this.$store.dispatch("branch/removeBranch", id).then(() => {
        //     this.deletePopupActive = false;
        //     this.$vs.notify({
        //       color: "success",
        //       title: "Silme İşlemi",
        //       text: "Şube Başarıyla Silindi",
        //     });
        //   });
        let newItemFull=this.data3.data.filter(item => item.id === this.selectedProduct.id);
        let newItem = {id: 0, price: this.additiveprice, priceListId: this.data, productId: newItemFull[0].id, productName: newItemFull[0].name,
        categoryName:newItemFull[0].categoryName, isExtra: newItemFull[0].isExtra };

        this.data2.data.push(newItem)
        this.data3.data = this.data3.data.filter(item => item.id !== this.selectedProduct.id);
        this.additiveprice=0;
        this.selectedProduct=null

        this.$vs.notify({
               color: "success",
               title: "Fiyat Ekleme İşlemi",
               text: "Başarıyla Fiyat Eklendi",
             });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Fiyat Ekleme İşlemi Başarısız !",
          });
        }
      });
    },
    editPrice(productId,price,isExtra) {
      this.newProductPrice.price =  parseFloat(price)
            this.newProductPrice.productId = parseFloat(productId)
            this.newProductPrice.branchProductPriceListId=parseFloat(this.data); 
            this.newProductPrice.isExtra = isExtra;
      setBranchProductPrice(this.newProductPrice).then((res) => {
        if (res && res.status == 200) {
        //   this.$store.dispatch("branch/removeBranch", id).then(() => {
        //     this.deletePopupActive = false;
        //     this.$vs.notify({
        //       color: "success",
        //       title: "Silme İşlemi",
        //       text: "Şube Başarıyla Silindi",
        //     });
        //   });
        this.$vs.notify({
               color: "success",
               title: "Fiyat Güncelleme İşlemi",
               text: "Başarıyla Fiyat Güncellendi",
             });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Fiyat Güncelleme İşlemi Başarısız !",
          });
        }
      });
    }
    }
  }
</script>